<script lang="ts">
    import {getLocalization} from 'core/svelte-context/context';

    const localize = getLocalization();
</script>

<h1>
    {localize(/* @kp-localization hledani.HistorieHledani */ 'hledani.HistorieHledani')}
</h1>

<style lang="less">
    h1 {
        margin: 0;
        width: 100%;
    }
</style>